function Footer() {
  return (
    <footer
      className="footer"
      style={{
        backgroundColor: "#9DA2AA",
        color: "white",

        textAlign: "center",
      }}
    >
      <div
        className="upperRow"
        style={{
          display: "flex",
          justifyContent: "space-between",
          paddingTop: "1rem",
          marginInline: "5%",
          marginBottom: "-1rem",
        }}
      >
        <div
          className="leftColumn"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <a
            href="/profile"
            style={{ textTransform: "uppercase", color: "white" }}
          >
            My Account
          </a>
          <a
            href="/dtf-sheet-builder"
            style={{ textTransform: "uppercase", color: "white" }}
          >
            Design Portal
          </a>
          <a
            href="/art-services"
            style={{ textTransform: "uppercase", color: "white" }}
          >
            Art Services
          </a>
          <a
            href="/contact"
            style={{ textTransform: "uppercase", color: "white" }}
          >
            Contact Us
          </a>
        </div>
        <div
          className="rightColumn"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "space-between",
          }}
        >
          <strong>Customer Support Hours</strong>
          <span>M-F: 9am - 5pm</span>
          <br />
          <span>360 E Maple Rd Suite M Troy, MI 48083</span>
          <span>Email: cs@seeourdesigns.com</span>
          <span>Phone: (313) 801-2500</span>
        </div>
      </div>
      <div className="bottomRow">
        <p style={{ fontSize: "0.9em" }}>
          © 2025 See Our Designs. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
